import React, { FunctionComponent, useEffect, useState, useMemo, useContext, useLayoutEffect } from 'react';
import * as echarts from 'echarts/core';
import { createLinearGradientColumn } from './const';
import {
  DatasetComponent,
  DatasetComponentOption,
  TooltipComponent,
  TooltipComponentOption,
  GridComponent,
  GridComponentOption,
  LegendComponent,
  LegendComponentOption
} from 'echarts/components';
import { BarChart, BarSeriesOption } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  DatasetComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BarChart,
  CanvasRenderer
]);

type EChartsOption = echarts.ComposeOption<
  | DatasetComponentOption
  | TooltipComponentOption
  | GridComponentOption
  | LegendComponentOption
  | BarSeriesOption
>;

let initOption: EChartsOption = {
  tooltip: {},
  dataset: {
    source: []
  },
  xAxis: { type: 'category' },
  yAxis: {},
  series: [{ type: 'bar' }],
};

interface IProps {
  dataSource: any;
  width: number;
  height: number;
  id: string;
  visibleKeys: string[];
}



const SuperTestBarChart: FunctionComponent<IProps> = ({ id, dataSource, width, height, visibleKeys }) => {
  const [option, setOption] = useState<EChartsOption>(initOption);

  const initChart = () => {
    let chartDom = document.getElementById(id)!;
    let myChart = echarts.init(chartDom);

    console.log(option)

    option && myChart.setOption(option, true);
  }

  const initOptionFn = () => {
    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      dataset: {
        source: []
      },
      xAxis: { type: 'category' },
      yAxis: {},
      series: [{ type: 'bar' }],
      grid: {
        x: 38,
        y: 25,
        x2: 10,
        y2: 25
      },
    }

    option.dataset.source = dataSource;

    if (dataSource?.[1] && dataSource?.[1].length !== 0) {
      const arr = dataSource?.[1].filter(item => typeof item === 'number');

      option.series = arr.map((_, inx) => ({
        type: 'bar',
        barWidth: (dataSource?.[1].length === 2) ? '30px' : 'auto',
        itemStyle: {
          color: createLinearGradientColumn(inx)
        },
      }));
  
      setOption(option as EChartsOption);
    }
  }

  useLayoutEffect(() => {
    if (visibleKeys.includes(id)) {
      console.log('bar Group')
      initOptionFn();
    }
  }, [dataSource, visibleKeys])

  useLayoutEffect(() => {
    initChart();
  }, [option])

  return (
    <div className="chart-wrapper">
      <div id={id} style={{ width: width + 'px', height: height + 'px', border: '1px solid #bbbbbb' }}></div>
    </div>
  )
}

export default SuperTestBarChart;